(() => {
  if (window.lvContactReady) return;
  window.lvContactReady = true;
  function setup(root) {
    for (const form of root.querySelectorAll('form.lv-contact-form')) {
      if (form.dataset.validationReady) continue;
      form.dataset.validationReady = 'true';
      form.noValidate = true;
      const fields = [...form.querySelectorAll('[data-error]')];
      const validate = field => {
        const valid = field.checkValidity() && (!field.required || field.value.trim().length > 0);
        const error = form.querySelector(`#${CSS.escape(field.getAttribute('aria-describedby'))}`);
        field.setAttribute('aria-invalid', String(!valid));
        error.textContent = valid ? '' : field.dataset.error;
        error.hidden = valid;
        return valid;
      };
      form.addEventListener('submit', event => {
        const invalid = fields.filter(field => !validate(field));
        if (invalid.length) { event.preventDefault(); invalid[0].focus(); }
      });
      for (const field of fields) field.addEventListener('input', () => {
        if (field.getAttribute('aria-invalid') === 'true') validate(field);
      });
    }
  }
  setup(document);
  document.addEventListener('shopify:section:load', event => setup(event.target));
})();
